import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import mainState from "../../Main/state";
import axios from 'axios';
const download = require("downloadjs");
// //////////////////
// Action Creators //
// //////////////////

export const filtroBusqueda = () => ({
  type: "SE/FILTRO_BUSQUEDA",
});

export const cargarPrestaciones = (prestaciones) => ({
  type: "SE/CARGAR_PRESTACIONES",
  prestaciones,
});

export const CargarSolicitudes = (solicitudes) => ({
  type: "SE/CARGAR_SOLICITUDES",
  solicitudes,
});

export const cargarTiposAtencion = (tiposAtencion) => ({
  type: "SE/CARGAR_TIPOS_ATENCION",
  tiposAtencion,
});

export const getSizeArchivo = (sizeArchivo) => ({
  type: "SE/GET_SIZE_ARCHIVO",
  sizeArchivo,
});

export const CambiarTipoAtencion = (tipoAtencion) => ({
  type: "SE/CAMBIAR_TIPO_ATENCION",
  tipoAtencion,
});

export const Loading = (loading) => ({
  type: "SE/LOADING",
  loading,
});

export const LoadingFile = (loadingFile) => ({
  type: "SE/LOADINGFILE",
  loadingFile,
});

export const LoadingSolicitudes = (value) => ({
  type: "SE/LOADING_SOLICITUDES",
  value,
});

export const LoadingErrores = (value) => ({
  type: "SE/LOADING_ERRORES",
  value,
});

export const CargarErrores = (errores) => ({
  type: "SE/CARGAR_ERRORES",
  errores,
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const GetSizeArchivo = () => (dispatch) => {
  //console.log("Action para obtener el nombre del archivo");
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    token: globalState.token,
  }
  //trace.information("se obtiene el size del archivo", JSON.stringify(params))

  fetch(`${apiConfig.apiUri}/v1/parametros/getSizeArchivo`, {
    method: "POST",
    headers: {},
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((response) => {
    //console.log(">>>>>>>>>>>>>>>>>>>>>>>> GET RESPONSE >>>", response)
    //trace.information("se obtiene el size del archivo")
    if (!response.ok) throw response;
    return response.json();
  }).then((json) => {
    if (Array.isArray(json)) {
      //trace.information("SE OBTIENE LA VARIABLE JSON", JSON.stringify(json));
      dispatch(getSizeArchivo(json));
    } else {
      throw json;
    }
  }).catch((error) => {
    trace.error("GetSizeArchivo", error);
    dispatch(ErrorSnacktOpen(
      "Error al obtener los tipos de atención:",
      error,
    ));
  })
}

export const BuscarPrestaciones = () => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaSE;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    pageNumber: 1,
    pageSize: 10,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  axios({
    method: "post",
    url: `${apiConfig.apiUri}/v1/prestaciones/prestador2/`,
    headers: {},
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    /*console.log("RESPONSE DESDE AXIOS API PRESTADOR2 FILTRO BUSQUEDA");
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);*/

    if (response.status === 200) {
      //console.log("RESPONSE OK");
      //console.log(response.data);

      if (Array.isArray(response.data)) {
        //trace.information("BuscarPrestaciones", response.data);
        dispatch(cargarPrestaciones(response.data));
      } else {
        throw response.data;
      }
    }
  }).catch((error) => {
    if (error.response) {
      console.log("MENSAJE DE Error 4xx");
      console.log(error);
    } else {
      console.log("MENSAJE DE Error 5xx");
      console.log(error);
    }
    trace.error("BuscarPrestaciones", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/prestador2/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  //   timeout: 9000,
  // })
  //   .then((response) => {
  //     if (!response.ok) { throw response; }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     if (Array.isArray(json)) {
  //       trace.information("BuscarPrestaciones", json);
  //       dispatch(cargarPrestaciones(json));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("BuscarPrestaciones", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar prestaciones:",
  //       error,
  //     ));
  //   });
};

export const obtenerCentrosAtencionAll = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/centroatencion/prestadorAll/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerCentrosAtencion", json);
        // dispatch(...);
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerCentrosAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los centros de atención:",
        error,
      ));
    });
};

export const obtenerTiposAtencion = () => (dispatch) => {
  // console.log("OBTENER TIPOS ATENCION");
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/tipoatencion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerTiposAtencion", json);
        dispatch(cargarTiposAtencion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerTiposAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de atención:",
        error,
      ));
    });
};

export const ObtenerSolicitudes = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    isapre: globalState.isapre,
    token: globalState.token,
  };


  dispatch(LoadingSolicitudes(true));
  fetch(`${apiConfig.apiUri}/v1/solicitudes/getSolicitudesEspeciales/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      //console.log("REPSONSE PARAMS GET SOLICITUDES ESPECIALES >> ", params);
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //console.log("REPSONSE PARAMS GET SOLICITUDES ESPECIALES >> ", params);
      if (Array.isArray(json)) {
        //trace.information("ObtenerSolicitudes", json);
        dispatch(CargarSolicitudes(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerSolicitudes", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener solicitudes:",
        error,
      ));
    });
};

export const GetPrestacionesExcel = () => (dispatch) => {
  const filtrosState = store.getState().filtroBusquedaSE;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  // axios({
  //   method: "post",
  //   url: `${apiConfig.apiUri}/v1/prestaciones/busquedaSolEspecialesExcel/`,
  //   credentials: "same-origin",
  //   data: { data: JSON.stringify(params) },
  // }).then((response) => {
  //   console.log("RESPONSE AXIOS DESCARGA DE EXCEL");
  //   if (response.status === 200){
  //     const blobFile = new Blob([response.data], { type: "application/octect-stream" });
  //     console.log(blobFile);
  //     dispatch(LoadingFile(false));
  //     download(blobFile, `prestaciones_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  //     // download(blobFile, "test.xlsx");
  //   }
  // }).catch((error) => {
  //   dispatch(LoadingFile(false));
  //   trace.error("GetSolicitudesExcel", error);
  //   dispatch(ErrorSnacktOpen(
  //     "Error al obtener GetSolicitudesExcel:",
  //     error,
  //   ));
  // });

  fetch(`${apiConfig.apiUri}/v1/prestaciones/busquedaSolEspecialesExcel/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    // mode: "opaque",
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      //console.log("BLOB FILE");
      //console.log(blob);
      dispatch(LoadingFile(false));
      download(blob, `prestaciones_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false));
      trace.error("GetSolicitudesExcel", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener GetSolicitudesExcel:",
        error,
      ));
    });
};

export const GetPrestacionesExcelCompleto = () => (dispatch) => {
  //const filtrosState = store.getState().filtroBusquedaSE;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: null,
    Aranceles: globalState.tiposArancelGeneral,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: null,
    Isapre: globalState.isapre,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/prestaciones/busquedaSolEspecialesExcel2/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    // mode: "opaque",
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      //console.log("BLOB FILE");
      //console.log(blob);
      dispatch(LoadingFile(false));
      download(blob, `prestaciones_${(new Date()).toLocaleDateString()}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      dispatch(LoadingFile(false));
      trace.error("GetSolicitudesExcelCompleto", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener GetSolicitudesExcelCompleto:",
        error,
      ));
    });
};

export const ProcesarSolicitudMasiva = (sizeArchivo, file, callbackExito, callbackError) => (dispatch) => {
  const globalState = store.getState().global;
  const { token, rutPrestador } = store.getState().global;

  const params = {
    RutPrestador: globalState.rutPrestador,
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    NombreArchivo: file.name,
    token: globalState.token,
    ListaUsuariosContraloria: globalState.listaUsuariosContraloria,
    ListaUsuariosConvenios: globalState.listaUsuariosConvenio,
    RutUsuario: globalState.rutUsuario,
  };

  //console.log("PROCESAR SOLICITID MASIVA PARAMS >>> ", params);

  const data = new FormData();
  data.append("solicitud", file);
  // data.append("data", JSON.stringify(params));

  //console.log("DATA FILE ");
  //console.log(sizeArchivo);

  if (file.size >= sizeArchivo) {
    dispatch(ErrorSnacktOpen("El archivo pesa más de 5 MB, no se puede subir"));
    return undefined;
  }


  fetch(`${apiConfig.apiUri}/v1/vigencias/getVigenciasPrestador`, {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify({ rutPrestador, token }),
  })
    .then((res) => {
      if (!res.ok) throw res;
      return res.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ProcesarSolicitudMasiva", json);
        if (json.length > 0) {
          params.fechaMinimaVigencia = new Date(json[0].fechaVigenciaPrestador);
          data.append("data", JSON.stringify(params));

          //console.log("DATA APPEND PROCESAR SOLICITUD MASIVA >>> ", data);

          fetch(`${apiConfig.apiUri}/v1/solicitudes/ProcesarSolicitudMasiva/`, {
            method: "POST",
            headers: {
              // "Content-Type": "application/json",
              // Authorization: localStorage.getItem('id_token'),
              token: globalState.token,
            },
            credentials: "same-origin",
            body: data,
          })
            .then((response) => {
              if (!response.ok) { throw response; }
              return response.json();
            })
            .then((json) => {
              //trace.information("ProcesarSolicitudMasiva", json);
              if (json && json.length > 0 && json[0] && json[0].SolicitudRecibida === true) {
                if (callbackExito) callbackExito();
              } else if (callbackError) callbackError();
            })
            .catch((error) => {
              trace.error("ProcesarSolicitudMasiva", error);
              dispatch(ErrorSnacktOpen(
                "Error al procesar solicitud masiva:",
                error,
              ));
            });
        } else {
          fetch(`${apiConfig.apiUri}/v1/vigencias/getVigenciaGeneral`, {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({ token }),
          })
            .then((res) => {
              if (!res.ok) throw res;
              return res.json();
            })
            .then((json) => {
              if (json) {
                //trace.information("ProcesarSolicitudMasiva", json);
                const today = new Date();
                today.setDate(today.getDate() + +json[0].days);
                params.fechaMinimaVigencia = today;

                data.append("data", JSON.stringify(params));

                fetch(`${apiConfig.apiUri}/v1/solicitudes/ProcesarSolicitudMasiva/`, {
                  method: "POST",
                  headers: {
                    // "Content-Type": "application/json",
                    // Authorization: localStorage.getItem('id_token'),
                    token: globalState.token,
                  },
                  credentials: "same-origin",
                  body: data,
                })
                  .then((response) => {
                    if (!response.ok) { throw response; }
                    return response.json();
                  })
                  .then((json) => {
                    //trace.information("ProcesarSolicitudMasiva", json);
                    if (json && json.length > 0 && json[0] && json[0].SolicitudRecibida === true) {
                      if (callbackExito) callbackExito();
                    } else if (callbackError) callbackError();
                  })
                  .catch((error) => {
                    trace.error("ProcesarSolicitudMasiva", error);
                    dispatch(ErrorSnacktOpen(
                      "Error al procesar solicitud masiva:",
                      error,
                    ));
                  });
              } else throw json;
            })
            .catch((err) => {
              //trace.information("ProcesarSolicitudMasiva", err);
              dispatch(ErrorSnacktOpen(
                "Error al obtener la vigencia general:",
                err,
              ));
            });
        }
      } else throw json;
    })
    .catch((err) => {
      //trace.information("ProcesarSolicitudMasiva", err);
      dispatch(ErrorSnacktOpen(
        "Error al obtener la vigencia general:",
        err,
      ));
    });
};

export const BuscarErrores = (idSolicitudEspecial) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    idSolicitudEspecial,
    token: globalState.token,
  };
  dispatch(LoadingErrores(true));
  fetch(`${apiConfig.apiUri}/v1/solicitudes/getErroresSE/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("BuscarErrores", json);
        dispatch(CargarErrores(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("BuscarErrores", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar errores de la solicitud:",
        error,
      ));
    });
};

export const CargarSelectItem = () => (dispatch) => {
  mainState.isLoading += 1;
};

export const DescargExcelGlosas = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    RutPrestador: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/getCodGlosasPorPrestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      download(blob, `Glosas_${globalState.rutInstitucion}_${globalState.isapre}.xlsx`, "application/vnd.ms-excel");
    })
    .catch((error) => {
      trace.error("DescargExcelGlosas", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener DescargExcelGlosas:",
        error,
      ));
    });
};

export const ValidarReplicaCentrosAtencionHomologos = (idSolicitud, success, reject) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/GetSecHomologasPorSol/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("ValidarCentrosAtencionReplicados", json);
      if (Array.isArray(json)) {
        const centrosNoEncontrados = json.filter((c) => c.CentroHomologoSecuencia == null).map((c) => c.CentroNombre);
        success(centrosNoEncontrados.length === 0, centrosNoEncontrados);
      } else {
        reject(false);
        throw json;
      }
    })
    .catch((error) => {
      reject(false);
      trace.error("ValidarCentrosAtencionReplicados", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar centros de atencion homologos:",
        error,
      ));
    });
};

export const ValidarReplicaSolicitudEnCurso = (idSolicitud, success, reject) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ValIsapreHomEnCursoPorSol/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("ValidarReplicaSolicitudEnCurso", json);
      if (Array.isArray(json)) {
        success(json.length === 0, json);
      } else {
        reject(false);
        throw json;
      }
    })
    .catch((error) => {
      reject(false);
      trace.error("ValidarReplicaSolicitudEnCurso", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar solicitud en curso para replica:",
        error,
      ));
    });
};

export const ValidarReplicaPrestHomologas = (idSolicitud, success, reject) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ValPrestHomPorSol/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("ValidarReplicaPrestHomologas", json);
      if (Array.isArray(json)) {
        const prestNoHomologas = json.filter((p) => !p.IdPrestacionHomologa || p.IdPrestacionHomologa === 0);
        success(prestNoHomologas.length === 0, prestNoHomologas);
      } else {
        reject(false);
        throw json;
      }
    })
    .catch((error) => {
      reject(false);
      trace.error("ValidarReplicaPrestHomologas", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar prestaciones homologas para replica:",
        error,
      ));
    });
};

export const AplicarReplicarSolicitud = (IdSolicitud, IdSolicitudEspecial, Isapre, success, fail) => (dispatch) => {
  /*
    * ===============================================================================
    * AplicarReplicarSolicitud: void
    *
    * @desc
    * Permite la replicación de carga masiva, previamente validada,
    * a la otra Isapre.
    *
    * @params in
    * IdSolicitud: number = 'Id de la solicitud',
    * IdSolicitudEspecial: number = 'Id de la Solicitud de Carga Masiva',
    * Isapre: string = 'B: Banmedica, T: Vida Tres',
    * rutInstitucion: number = 'Rut de la Institución',
    * rutPrestador: number = 'Rut del Prestador',
    * rutUsuario: number = 'Rut del Usuario',
    * token: string = 'Autentificador con la API',
    *
    * @params get: string
    * message: string = 'Mensaje de error u OK según exito o fracaso de la función'
    * ================================================================================
  */

  // x: y , es la sintaxis para dar alias a la variable a través del Object Destructuring
  const {
    token, rutInstitucion: RutInstitucion, rutPrestador: RutPrestador, rutUsuario: RutUsuario,
  } = store.getState().global;

  const params = {
    IdSolicitud,
    IdSolicitudEspecial,
    Isapre,
    RutInstitucion,
    RutPrestador,
    RutUsuario,
    token,
  };

  //console.log("RESPONSE replicar carga masiva >> ", params);
  //console.log("RESPONSE replicar carga masiva >> ", params);


  fetch(`${apiConfig.apiUri}/v1/solicitudes/ReplicarCargaMasiva/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("ReplicarCargaMasiva", json);
      if (Array.isArray(json)) {
        if (json[0].result == "OK") {
          success();
        } else {
          fail();
        }
      } else {
        // reject(false);
        throw json;
      }
    })
    .catch((error) => {
      // reject(false);
      trace.error("ReplicarCargaMasiva", error);
      dispatch(ErrorSnacktOpen(
        "Error al replicar a la otra isapre en carga masiva:",
        error,
      ));
    });
};
